import { IOpcion, Opcion } from './opcion.model';
import { ITipoPregunta, TipoPregunta } from './tipo-pregunta.model';
import { IRango, Rango } from './rango.model';

export interface IPregunta {
  idPregunta: string;
  pregunta: string;
  idTipoPregunta: string;
  tipoPregunta?: ITipoPregunta;
  opciones?: IOpcion[];
  rangos?: IRango[];
}

export class Pregunta {
  idPregunta: string;
  pregunta: string;
  idTipoPregunta: string;
  tipoPregunta?: TipoPregunta;
  opciones: Opcion[];
  rango?: number;
  respuesta?: Opcion;
  respuestas: Opcion[] = [];
  rangos: Rango[];

  constructor(data: IPregunta) {
    this.idPregunta = data.idPregunta;
    this.pregunta = data.pregunta;
    this.idTipoPregunta = data.idTipoPregunta;
    this.tipoPregunta = data.tipoPregunta 
      ? new TipoPregunta(data.tipoPregunta) 
      : undefined;
    this.opciones = data.opciones
      ? data.opciones.map(
          r => new Opcion(r)
        )
      : [];
    this.rangos = data.rangos
      ? data.rangos.map(
          r => new Rango(r)
        )
      : [];
  }
}
